<template>
  <div class="big">
    <div class="page_title">公告模板</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div class="searchbox">
          <div>
            <span>公告标题/内容</span>
            <el-input
              v-model="keywords"
              style="width: 160px; margin: 0 20px 0 10px"
              @change="search"
              clearable
            ></el-input>
            <el-button
              type="info"
              style="background-color: #eceff2; color: #747981"
              @click="search"
            >查询</el-button>
            <span style="margin: 0 10px 0 15px">状态</span>
            <el-radio-group
              v-model="status"
              @change="search"
            >
              <el-radio :label="''">全部</el-radio>
              <el-radio :label="1">已启用</el-radio>
              <el-radio :label="0">已禁用</el-radio>
            </el-radio-group>
          </div>
          <el-button
            type="primary"
            @click="AddNotice"
            style="width: 120px"
            :disabled="module_id_array[0] ? !module_id_array.includes('1272') : false"
          >新建模板</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column label="排序">
              <template slot-scope="scope">
                <el-input-number
                  style="width:120px"
                  v-model="scope.row.sort"
                  @blur="updateNoticeTcmSort(scope.row.sort,scope.row.tcm_id)"
                  :min="1"
                  :precision="0"
                  :controls="false"
                  :disabled="module_id_array[0] ? !module_id_array.includes('1271') : false"
                ></el-input-number>
              </template>

            </el-table-column>
            <el-table-column
              label="公告标题"
              prop="title"
            ></el-table-column>
            <el-table-column
              label="公告内容"
              prop="content"
              width="500"
            ></el-table-column>
            <el-table-column
              label="引用数量"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  style="margin-left:5px"
                  @click="quoteDetail(scope.row.tcm_id,scope.row.quote_num)"
                  :disabled="module_id_array[0] ? !module_id_array.includes('1270') : false"
                >{{scope.row.quote_num}}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
            ></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status">已启用</span>
                <span
                  v-else
                  style="color: #e53528"
                >已禁用</span>
                <el-switch
                  style="margin-left:6px"
                  v-model="scope.row.status"
                  active-color="#669961"
                  :active-value="1"
                  :inactive-value="0"
                  @change="value=>{return editStatus(value,scope.row.tcm_id)}"
                  :disabled="module_id_array[0] ? !module_id_array.includes('1268') : false"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="120"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status==0"
                  type="text"
                  style="margin-left:5px"
                  @click="editNotice(scope.row)"
                  :disabled="module_id_array[0] ? !module_id_array.includes('1273') : false"
                >编辑</el-button>
                <el-button
                  type="text"
                  style="margin-left:5px"
                  @click="delNotice(scope.row.tcm_id)"
                  :disabled="module_id_array[0] ? !module_id_array.includes('1269') : false"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 添加模板弹窗 -->
    <el-dialog
      title="公告模板"
      :visible.sync="addnotice"
      width="550px"
      :close-on-click-modal="false"
    >
      <div class="myform">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="110px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="公告标题"
            prop="title"
          >
            <el-input
              placeholder="请输入标题"
              v-model="ruleForm.title"
              maxlength="100"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="公告内容"
            prop="content"
          >
            <el-input
              type="textarea"
              :rows="6"
              placeholder="请输入内容"
              v-model="ruleForm.content"
              maxlength="1000"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: left; padding: 100px 0 20px 110px">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="submit('ruleForm')"
            style="width: 92px"
            size="medium"
          >保 存</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 引用详情弹窗 -->
    <el-dialog
      title="引用详情"
      :visible.sync="doctordata"
      width="600px"
      :close-on-click-modal="false"
    >
      <div style="padding:20px">
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="doctorData"
            tooltip-effect="dark"
            style="width: 100%; "
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="医生姓名"
              align="center"
              prop="doctor_name"
            ></el-table-column>
            <el-table-column
              label="医生手机号"
              align="center"
              prop="phone"
            ></el-table-column>
            <el-table-column
              label="引用时间"
              align="center"
              prop="create_time"
            >
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="doctorSizeChange"
            @current-change="doctorCurrentChange"
            :current-page="doctorPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="doctorSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="doctorNum"
            style="margin:20px 0 0"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      keywords: '',
      status: '',
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      addnotice: false,
      ruleForm: {
        title: '',
        content: ''
      },
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [
          { required: true, message: '请输入公告内容', trigger: 'blur' }
        ]
      },
      doctorData: [],
      doctorPage: 1,
      doctorSize: 10,
      doctorNum: 0,
      doctordata: false
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        status: this.status,
        keywords: this.keywords,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      this.axios.post('platform/Admin/noticeTcmList', data).then((res) => {
        if (res.code == 0) {
          if (!res.data.list.length && this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this.getList();
          }
          this.tableData = res.data.list.map((item) => {
            item.create_time = dayjs
              .unix(item.create_time)
              .format('YYYY-MM-DD HH:mm');
            item.last_time =
              item.last_time == '永久'
                ? item.last_time
                : dayjs.unix(item.last_time).format('YYYY-MM-DD HH:mm');
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //添加用户按钮
    AddNotice() {
      this.ruleForm = {
        title: '',
        content: ''
      };
      this.addnotice = true;
    },
    //编辑用户按钮
    editNotice(row) {
      this.ruleForm = {
        tcm_id: row.tcm_id,
        title: row.title,
        content: row.content
      };
      this.addnotice = true;
    },
    //添加
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm;
          let url = 'platform/Admin/addNoticeTcm';
          if (data.tcm_id) {
            url = 'platform/Admin/updateNoticeTcm';
          }
          this.axios.post(url, data).then((res) => {
            if (res.code == 0) {
              this.$message.success('保存成功');
              this.addnotice = false;
              this.getList();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //作废 恢复
    editStatus(status, tcm_id) {
      let msg = '确定禁用该公告模板吗？';
      if (status) {
        msg = '确定启用该公告模板吗？';
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/Admin/updateNoticeTcmStatus', {
              tcm_id,
              status
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('状态已修改');
                this.getList();
              }
            });
        })
        .catch(() => {
          this.getList();
        });
    },
    //修改排序
    updateNoticeTcmSort(sort, tcm_id) {
      if (!sort) {
        sort = 1;
      }
      let data = {
        tcm_id: tcm_id,
        sort: sort
      };
      this.axios
        .post('platform/Admin/updateNoticeTcmSort', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('排序已修改');
            this.getList();
          }
        });
    },
    delNotice(tcm_id) {
      this.$confirm('是否确定删除公告模板？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/Admin/deleteNoticeTcm', { tcm_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('公告模板已删除');
                this.getList();
              }
            });
        })
        .catch(() => {
          this.getList();
        });
    },
    quoteDetail(tcm_id, num) {
      this.tcm_id = tcm_id;
      this.num = num;
      if (!num) {
        return false;
      }
      let data = {
        tcm_id: this.tcm_id,
        page: this.doctorPage,
        pageNumber: this.doctorSize
      };
      this.axios.post('platform/Admin/quoteDetail', data).then((res) => {
        if (res.code == 0) {
          this.doctorData = res.data.list.map((item) => {
            item.create_time = dayjs
              .unix(item.create_time)
              .format('YYYY-MM-DD HH:mm');
            return item;
          });
          this.doctorNum = res.data.total;
          this.doctordata = true;
        }
      });
    },
    //每页数据的条数
    doctorSizeChange(size) {
      this.doctorSize = size;
      this.quoteDetail(this.tcm_id, this.num);
    },
    //当前第几页
    doctorCurrentChange(currentPage) {
      this.doctorPage = currentPage;
      this.quoteDetail(this.tcm_id, this.num);
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 500px;
  padding-top: 20px;
  text-align: left;
}
</style>